import {useEffect} from 'react';
import {useHistory} from 'react-router-dom';

import {getRouteMatch} from '../../../../routes/utils';
import {
  initializeCriticalWorkflowPainWindowMonitoring,
  observeCriticalWorkflowPainWindow,
} from './observer';

export const usePainWindowMonitoring = () => {
  const history = useHistory();

  useEffect(() => initializeCriticalWorkflowPainWindowMonitoring(), []);

  useEffect(() => {
    let previousPathname = history.location.pathname;
    return history.listen((location, action) => {
      if (location.pathname === previousPathname) {
        return;
      }
      const fromRoutePattern =
        getRouteMatch(previousPathname)?.path ?? 'unmatched';
      const toRoutePattern =
        getRouteMatch(location.pathname)?.path ?? 'unmatched';
      previousPathname = location.pathname;
      observeCriticalWorkflowPainWindow({
        workflow: 'route-changed',
        windowDurationMs: 10_000,
        workflowContext: {
          fromRoutePattern,
          toRoutePattern,
          navigationAction: action,
        },
      });
    });
  }, [history]);
};
